export default __webpack_public_path__ + "static/media/poster4-03.b9db976f.jpg";